const thumbnailCache = new Map()

export const getThumbnailFromCache = (imageId) => {
  return thumbnailCache.get(imageId)
}

export const addThumbnailToCache = (imageId, url) => {
  thumbnailCache.set(imageId, url)
}

export const removeThumbnailFromCache = (imageId) => {
  thumbnailCache.delete(imageId)
}

export const clearThumbnailCache = () => {
  thumbnailCache.clear()
} 